import { Ticket, Area, ProductCategory, Medium, RelatedCard, RidangoReduxAction } from '@ridango/core';
import { Injectable } from '@angular/core';
import { Action } from 'redux';






export interface TicketAction extends Action {

    type: string;

    payload?: any;
}



@Injectable()
export class TicketActions {


    static CREATE_TICKET = '[Ticket]: Create new ticket'; // done
    static REMOVE_TICKET = '[Ticket]: Remove ticket';
    static CLEAR_TICKETS = '[Ticket] Clear all local tickets';

    static SET_TICKET_START_DATE = '[Ticket]: Set ticket start date'; // done
    static SET_TICKET_END_DATE = '[Ticket]: Set ticket end date'; // done
    static UNSET_TICKET_DATES = '[Ticket]: Unset ticket dates';
    static SET_TICKET_ORIGIN_STOP = '[Ticket]: Set ticket origin stop';
    static SET_TICKET_DESTINATION_STOP = '[Ticket]: Set ticket destination stop';
    static SET_TICKET_ORIGIN_ZONE_ID = '[Ticket]: Set ticket origin zone id';
    static SET_TICKET_DESTINATION_ZONE_ID = '[Ticket]: Set ticket destination zone id';
    static SET_TICKET_ORIGIN_ZONE_NAME = '[Ticket]: Set ticket origin zone name';
    static SET_TICKET_DESTINATION_ZONE_NAME = '[Ticket]: Set ticket destination zone name';



    static SET_TICKET_REGION_LOGOS = '[Ticket]: Set ticket region logos';
    static SET_TICKET_PRICE = '[Ticket]: Set ticket price';
    static SET_TICKET_PRODUCT = '[Ticket]: Set ticket product';
    static SET_PRODUCT_TYPE = '[Ticket]: Set product type';
    static SET_PRODUCT_CATEGORY_IDS = '[Ticket]: Set product category ids';

    static SET_TICKET_ZONES_REVERSED = '[Ticket]: Set ticket zones reversed';




    static SET_RENEW_TICKET = '[Ticket]: Set renew ticket';
    static REMOVE_RENEW_TICKET = '[Ticket]: Remove renew ticket';



    static SET_AREA = '[Ticket]: Set area';
    static SET_TRAVELLER_CATEGORY = '[Ticket]: Set traveller category';
    static SET_PRODUCT_CATEGORY = '[Ticket]: Set product category';
    static SET_MEDIUM = '[Ticket]: Set medium';
    static SET_RELATED_CARD = '[Ticket]: Set related card';


    static SET_RELATED_CARD_TICKETS = '[Ticket] Set related card tickets';
    static SET_TRAVEL_CARDS_TO_TICKET = '[Ticket] Set travel cards to ticket';
    static SET_MEDIUMS_TO_TICKET = '[Ticket] Set mediums to ticket';
    static SET_EMAILS_TO_TICKET = '[Ticket] Set emails to ticket';
    static TOGGLE_SELECTED_RELATED_CARD = '[Ticket] Toggle Selected Related Card';
    static TOGGLE_ALL_RELATED_CARDS = '[Ticket] Toggle All Related Cards';
    static SET_CORPORATE_PRICE = '[Ticket] Set corporate price';

    static SET_EMAIL_TICKET = '[Ticket]: Set email ticket';
    static CLEAR_EMAIL_TICKETS = '[Ticket]: Clear email tickets';



    static SET_VOUCHER_TICKET = '[Ticket]: Set voucher ticket';
    static SET_SELECTED_VOUCHER_TICKET = '[Ticket]: Set selected voucher ticket';
    static SET_VOUCHER_SUB_TICKET = '[Ticket]: Set voucher sub ticket';
    static CLEAR_VOUCHERS = '[Ticket]: Clear vouchers';

    static SET_AMOUNT_OF_TICKETS = '[Ticket]: Set amount of tickets';

    static SET_AVAILABLE_TICKET_MEDIUM_TYPES = '[Ticket]: Set available medium types';

    static SET_RENEWABLE_TICKET = '[Ticket]: Set renewable ticket';
    static SET_REFUND_TICKET = '[Ticket] Set refund ticket';

    setStartingDate ( payload: any ): TicketAction {
        return {
            type: TicketActions.SET_TICKET_START_DATE,
            payload: payload
        };
    }
    setEndingDate ( payload: any ): TicketAction {
        return {
            type: TicketActions.SET_TICKET_END_DATE,
            payload: payload
        };
    }
    unsetTicketDates(payload: any): TicketAction {
        return {
            type: TicketActions.UNSET_TICKET_DATES,
            payload: payload
        };
    }
    createTicket ( payload: Ticket ): TicketAction {
        return {
            type: TicketActions.CREATE_TICKET,
            payload: payload
        };
    }

    setProduct ( payload: any ): TicketAction {
        return {
            type: TicketActions.SET_TICKET_PRODUCT,
            payload: payload
        };
    }
    setOriginStop ( payload: any ): TicketAction {
        return {
            type: TicketActions.SET_TICKET_ORIGIN_STOP,
            payload: payload
        };
    }
    setDestinationStop ( payload: any ): TicketAction {
        return {
            type: TicketActions.SET_TICKET_DESTINATION_STOP,
            payload: payload
        };
    }

    clearAllTickets (): TicketAction {
        return {
            type: TicketActions.CLEAR_TICKETS
        };
    }
    removeTicket ( payload: Ticket ): TicketAction {
        return {
            type: TicketActions.REMOVE_TICKET,
            payload: payload
        };
    }
    setTicketPrice ( payload: any ): RidangoReduxAction {
        return {
            type: TicketActions.SET_TICKET_PRICE,
            payload: payload
        };
    }

    setRenewTicket ( payload ): TicketAction {
        return {
            type: TicketActions.SET_RENEW_TICKET,
            payload: payload
        };
    }
    removeRenewTicket (): TicketAction {
        return {
            type: TicketActions.REMOVE_RENEW_TICKET
        };
    }

    setRefundTicket( payload ): TicketAction {
        return {
            type: TicketActions.SET_REFUND_TICKET,
            payload: payload
        }
    }

    setArea ( uid: string, area: Area ): TicketAction {
        return {
            type: TicketActions.SET_AREA,
            payload: { uid: uid, area: area }
        };
    }
    setTravellerCategory ( uid: string, category: ProductCategory ): TicketAction {
        return {
            type: TicketActions.SET_TRAVELLER_CATEGORY,
            payload: { uid: uid, travellerCategory: category }
        };
    }

    setProductCategory ( uid: string, category: ProductCategory ): TicketAction {
        return {
            type: TicketActions.SET_PRODUCT_CATEGORY,
            payload: { uid: uid, productCategory: category }
        };
    }
    setMedium ( uid: string, medium: Medium ): TicketAction {
        return {
            type: TicketActions.SET_MEDIUM,
            payload: { uid: uid, medium: medium }
        };
    }

    setRelatedCard ( uid: string, card: RelatedCard ): TicketAction {
        return {
            type: TicketActions.SET_RELATED_CARD,
            payload: { uid: uid, card: card }
        };
    }

    setRelatedCardTickets ( card: RelatedCard, tickets: Ticket[] ) {
        return {
            type: TicketActions.SET_RELATED_CARD_TICKETS,
            payload: { ...{}, [ card.id ]: tickets }
        };
    }

    setTravelCardsToTicket ( travelCardsIds: number[], uid: string ) {
        return {
            type: TicketActions.SET_TRAVEL_CARDS_TO_TICKET,
            payload: { uid: uid, travelCardsIds: travelCardsIds }
        };
    }

    setMediumsToTicket ( mediumNums: string[], uid: string ) {
        return {
            type: TicketActions.SET_MEDIUMS_TO_TICKET,
            payload: { uid: uid, mediumNums: mediumNums }
        }
    }

    setEmailsToTicket ( emails: string[], uid: string ) {
        return {
            type: TicketActions.SET_EMAILS_TO_TICKET,
            payload: { uid: uid, emails: emails }
        }
    }


    setCorporatePrice ( uid ) {
        return {
            type: TicketActions.SET_CORPORATE_PRICE,
            payload: uid
        };
    }

    toggleSelectedRelatedCard ( travelCardId, uid ) {
        return {
            type: TicketActions.TOGGLE_SELECTED_RELATED_CARD,
            payload: { uid: uid, travelCardId: travelCardId }
        };
    }

    toggleAllRelatedCards ( travelCardsIds, uid ): RidangoReduxAction {
        return {
            type: TicketActions.TOGGLE_ALL_RELATED_CARDS,
            payload: { uid: uid, travelCardsIds: travelCardsIds }
        };
    }

    setEmailTicket ( ticket ): RidangoReduxAction {
        return {
            type: TicketActions.SET_EMAIL_TICKET,
            payload: ticket
        };
    }

    clearEmailTickets (): RidangoReduxAction {
        return {
            type: TicketActions.CLEAR_EMAIL_TICKETS
        };
    }




    setVoucherTicket ( ticket ): RidangoReduxAction {
        return {
            type: TicketActions.SET_VOUCHER_TICKET,
            payload: ticket
        };
    }
    setVoucherSubTicket ( ticket ): RidangoReduxAction {
        return {
            type: TicketActions.SET_VOUCHER_SUB_TICKET,
            payload: ticket
        };
    }
    clearVouchers (): RidangoReduxAction {
        return {
            type: TicketActions.CLEAR_VOUCHERS
        };
    }
    setSelectedVoucherTicket ( ticket ): RidangoReduxAction {
        return {
            type: TicketActions.SET_SELECTED_VOUCHER_TICKET,
            payload: ticket
        };
    }

    setAmountOfTickets ( uid: string, amount: number ): RidangoReduxAction {
        return {
            type: TicketActions.SET_AMOUNT_OF_TICKETS,
            payload: { uid: uid, amount: amount }
        };
    }

    setAvailableMediumTypes ( types ): RidangoReduxAction {
        return {
            type: TicketActions.SET_AVAILABLE_TICKET_MEDIUM_TYPES,
            payload: types
        };
    }

    setRenewableTicket( ticket ): RidangoReduxAction {
        return {
            type: TicketActions.SET_RENEWABLE_TICKET,
            payload: ticket
        };
    }
}
